export default {
  language: 'Idioma',
  save: 'Guardar',
  saving: 'Guardando…',
  cancel: 'Cancelar',
  close: 'Cerrar',
  loading: 'Cargando…',
  search: 'Buscar',
  edit: 'Editar',
  remove: 'Quitar',
  saved: 'Guardado',
  somethingWentWrong: 'Algo salió mal. Intente otra vez.',
  required: 'Obligatorio',
}
